import React, { Fragment, Component } from "react";
import { withRouter } from "react-router";
import {
  Col,
  Container,
  Row,
  Spinner,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import IndexBloc from "../../Blocs/IndexBloc";
import { Line } from "react-chartjs-2";
import apiResponse from "../../../../../../services/apiResponse";
import {
  Document,
  Packer,
  Paragraph,
  ImageRun,
  TextRun,
  AlignmentType,
} from "docx";
import { saveAs } from "file-saver";
import image from "../../../../../../assets/images/BKPM NEW 1.png";

class IndexView extends Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.state = {
      data: null,
      dataHistory: null,
      loading: false,
      hoveredDesc: false,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({ loading: true, errorMessage: null });

    this.indexBloc.getGraphDiskUtilization6MonthChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          let errormessage = result.data.message;
          // console.log(response);
          this.setState({
            data: response,
            loading: false,
            errorMessage: errormessage,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            errorMessage: "Failed to load data. Please try again.",
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.fetchGraphDiskUtilization6Month({});

    this.indexBloc.getGraphDiskUtilization6MonthHistoryChannel.subscribe(
      (result) => {
        switch (result.status) {
          case apiResponse.COMPLETED:
            let response = result.data.response;
            this.setState({
              dataHistory: response,
              loading: false,
            });
            break;
          case apiResponse.ERROR:
            this.setState({
              loading: false,
            });
            break;
          default:
            break;
        }
      }
    );

    this.indexBloc.fetchGraphDiskUtilization6MonthHistory({});
  };

  // createChart = () => {
  //   const { selectedHost } = this.props;
  //   const { dataHistory } = this.state;

  //   const defaultChartData = {
  //     labels: [],
  //     datasets: [],
  //   };

  //   if (!selectedHost) {
  //     return defaultChartData;
  //   }

  //   const value = selectedHost.value;

  //   const specificHost = Array.isArray(dataHistory)
  //     ? dataHistory.find((item) => item.host.hostid === value)
  //     : null;

  //   const graphId = specificHost ? specificHost.graph.graphid : null;

  //   const specificGraph = Array.isArray(this.state.dataHistory)
  //     ? this.state.dataHistory.find((item) => item.graph.graphid === graphId)
  //     : null;

  //   const items =
  //     specificGraph && Array.isArray(specificGraph.graph.items)
  //       ? specificGraph.graph.items
  //       : [];

  //   const datasets = items.map((item, index) => {
  //     const dataPoints = item.values.map((value) => parseFloat(value.last));

  //     return {
  //       label: item.name,
  //       data: dataPoints,
  //       borderColor: this.getColorForItem(index),
  //       backgroundColor: this.getColorForItem(index),
  //       fill: false,
  //       tension: 0.1,
  //     };
  //   });

  //   const labels =
  //     items.length > 0 && items[0].values
  //       ? items[0].values.map((value) => value.timestamp)
  //       : [];

  //   return {
  //     labels: labels,
  //     datasets: datasets,
  //   };
  // };

  createChart = () => {
    const { selectedHost } = this.props;
    const { dataHistory } = this.state;

    const defaultChartData = {
      labels: [],
      datasets: [],
    };

    if (!selectedHost) {
      return defaultChartData;
    }

    const value = selectedHost.value;

    const specificHost = Array.isArray(dataHistory)
      ? dataHistory.find((item) => item.host.hostid === value)
      : null;

    const itemId = specificHost?.graph?.[0]?.itemid || null;

    const specificItem = Array.isArray(this.state.dataHistory)
      ? this.state.dataHistory.find(
          (item) => item.graph?.[0]?.itemid === itemId
        )
      : null;

    const items =
      specificItem && Array.isArray(specificItem.graph)
        ? specificItem.graph
        : [];

    const datasets = items.map((item, index) => {
      const dataPoints = Array.isArray(item.items)
        ? item.items.map((value) => parseFloat(value.last))
        : [];

      return {
        label: item.name,
        data: dataPoints,
        borderColor: this.getColorForItem(index),
        backgroundColor: this.getColorForItem(index),
        fill: false,
        tension: 0.1,
      };
    });

    const labels = (() => {
      if (items.length === 0 || items[0].items.length === 0) {
        return [];
      }

      const values = items[0].items;
      const groupedByMonth = {};

      values.forEach((value, index) => {
        const date = new Date(value.timestamp);
        const monthYear = `${date.getFullYear()}-${date.getMonth()}`;
        if (!groupedByMonth[monthYear]) {
          groupedByMonth[monthYear] = [];
        }
        groupedByMonth[monthYear].push(index);
      });

      const labels = values.map(() => "");
      Object.keys(groupedByMonth).forEach((monthYear) => {
        const indices = groupedByMonth[monthYear];
        const middleIndex = indices[Math.floor(indices.length / 2)];
        const date = new Date(values[middleIndex].timestamp);
        labels[middleIndex] = date.toLocaleDateString("id-ID", {
          month: "short",
        });
      });

      return labels;
    })();

    return {
      labels: labels,
      datasets: datasets,
    };
  };

  getColorForItem = (index) => {
    const colors = [
      "rgba(255, 176, 0, 0.8)",
      "rgba(255, 24, 169, 0.8)",
      "rgba(137, 8, 241, 0.8)",
    ];
    return colors[index % colors.length];
  };

  renderDiskUtilInfo = () => {
    const { selectedHost } = this.props;
    const { data, dataHistory } = this.state;

    if (!selectedHost) {
      return <div>Tidak ada host yang dipilih.</div>;
    }

    const value = selectedHost.value;

    const specificHost = Array.isArray(data)
      ? data.find((item) => item.host.hostid === value)
      : null;

    const itemId = specificHost?.graph?.[0]?.itemid || null;

    const specificItem = Array.isArray(this.state.data)
      ? this.state.data.find((item) => item.graph?.[0]?.itemid === itemId)
      : null;

    const items =
      specificItem && Array.isArray(specificItem.graph)
        ? specificItem.graph
        : [];

    if (items.length === 0) {
      return <div>Tidak ada informasi tersedia untuk host yang dipilih.</div>;
    }

    const specificHistory = Array.isArray(dataHistory)
      ? dataHistory.find((history) => history.graph?.[0]?.itemid === itemId)
      : null;

    const historyItems =
      specificHistory && Array.isArray(specificHistory.graph)
        ? specificHistory.graph
        : [];

    if (historyItems.length === 0) {
      return <div>Tidak ada informasi tersedia untuk host yang dipilih.</div>;
    }

    return (
      <div>
        <div>
          <div style={{ fontWeight: "bold", fontSize: "20px" }}>
            Informasi{" "}
            <span
              className="uil-info-circle"
              onMouseEnter={() => this.setState({ hoveredDesc: true })}
              onMouseLeave={() => this.setState({ hoveredDesc: false })}
              style={{ cursor: "pointer" }}
            />
          </div>
          <br />
        </div>
        {this.state.hoveredDesc && (
          <div
            style={{
              position: "absolute",
              background: "#f4f4f4",
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "10px",
              zIndex: 1000,
              width: "900px",
              boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            }}
          >
            {this.renderDescDescriptions()}
          </div>
        )}

        {items.map((item, index) => {
          const historyItem = historyItems.find(
            (history) => history.itemid === item.itemid
          );

          const last = item.last !== null ? item.last : "0.000";
          const min =
            historyItem && historyItem.min ? historyItem.min : "0.000";
          const max =
            historyItem && historyItem.max ? historyItem.max : "0.000";
          const average =
            historyItem && historyItem.average ? historyItem.average : "0.000";

          return (
            <div key={index}>
              <strong>{item.name}</strong> : <strong>Last:</strong> {last}%{" "}
              <strong>|</strong> <strong>Min:</strong> {min}% <strong>|</strong>{" "}
              <strong>Average:</strong> {average}% <strong>|</strong>{" "}
              <strong>Max:</strong> {max}%
            </div>
          );
        })}
      </div>
    );
  };

  renderDescDescriptions = () => {
    const desc = [
      {
        level: "Space Utilization",
        description:
          "Persentase penggunaan space yang mengindikasikan seberapa penuh atau sibuk dalam menjalankan operasi.",
      },
    ];

    return (
      <div>
        {desc.map((item, index) => (
          <div key={index}>
            <strong>{item.level}:</strong> {item.description}
          </div>
        ))}
      </div>
    );
  };

  handleDownloadWord = () => {
    const chartInstance = this.chartRef;

    if (!chartInstance) {
      console.error("Chart instance not found.");
      return;
    }

    const imgData = chartInstance.toBase64Image();

    const { selectedHost } = this.props;
    const value = selectedHost.label;

    const currentDate = new Date();
    const options = { day: "numeric", month: "long", year: "numeric" };
    const formattedDate = currentDate.toLocaleDateString("id-ID", options);

    const chartData = this.createChart();
    const analysisResults = this.analyzeChartData(chartData.datasets);

    const analysisParagraphs = analysisResults.map(
      (result) =>
        new Paragraph({
          spacing: { after: 80 },
          children: [
            new TextRun({
              text: `Grafik ${result.label}: Rata-rata ${result.average}% (`,
              font: "Arial",
              size: 20,
            }),
            new TextRun({
              text: result.status,
              font: "Arial",
              size: 20,
              bold: true,
            }),
            new TextRun({
              text: `)`,
              font: "Arial",
              size: 20,
            }),
          ],
        })
    );

    let paragraphText;
    if (this.allGood(analysisResults)) {
      paragraphText =
        "Disk utilization yang berada di bawah 80% menunjukkan bahwa sistem memiliki cukup ruang disk untuk menyimpan data dan menjalankan proses tanpa hambatan. Kondisi ini menandakan bahwa ruang penyimpanan dikelola dengan baik dan sistem tidak terancam kehabisan ruang dalam waktu dekat. Dengan kapasitas disk yang cukup, kinerja sistem tetap optimal dan resiko kegagalan akibat kekurangan ruang penyimpanan dapat diminimalisir.";
    } else if (this.allWarning(analysisResults)) {
      paragraphText =
        "Disk utilization yang berada di kisaran 80% hingga 85% menunjukkan bahwa ruang penyimpanan mulai terisi lebih banyak, tetapi masih dalam batas yang aman. Meskipun sistem masih dapat berjalan dengan normal, kondisi ini menandakan bahwa perlu ada perhatian lebih lanjut untuk menghindari penggunaan ruang yang semakin tinggi. Jika dibiarkan tanpa pengelolaan, risiko kehabisan ruang disk dalam waktu dekat dapat meningkat, yang bisa mempengaruhi kinerja sistem atau bahkan menyebabkan kegagalan aplikasi.";
    } else if (this.allBad(analysisResults)) {
      paragraphText =
        "Disk utilization yang melebihi 85% menunjukkan bahwa ruang penyimpanan hampir penuh, yang dapat menyebabkan masalah serius pada sistem. Kondisi ini berisiko tinggi, karena sistem mungkin kesulitan untuk menyimpan data baru atau menjalankan proses yang membutuhkan ruang disk tambahan. Penggunaan ruang yang sangat tinggi dapat menyebabkan penurunan kinerja, gangguan operasional, atau bahkan kegagalan aplikasi. Tindakan segera diperlukan, seperti membersihkan file yang tidak diperlukan atau menambah kapasitas penyimpanan untuk mencegah kerusakan lebih lanjut pada sistem.";
    } else if (this.allIdle(analysisResults)) {
      paragraphText =
        "Disk utilization yang berada pada 0% menunjukkan bahwa sistem dalam keadaan idle atau tidak ada aktivitas yang menggunakan ruang penyimpanan. Kondisi ini bisa terjadi pada sistem yang baru dinyalakan atau server yang tidak menjalankan aplikasi atau layanan apapun. Meskipun tidak berbahaya, kondisi ini menunjukkan bahwa ruang penyimpanan tidak dimanfaatkan dengan baik, dan dapat memberikan peluang untuk memanfaatkan ruang disk tersebut secara lebih efisien untuk menyimpan data atau file yang diperlukan.";
    }

    this.convertImageToBase64(image).then((base64Image) => {
      const doc = new Document({
        sections: [
          {
            properties: {},
            children: [
              // COVER PAGE
              new Paragraph({
                spacing: {
                  after: 500,
                },
                alignment: AlignmentType.RIGHT,
                children: [
                  new ImageRun({
                    data: base64Image,
                    transformation: { width: 250, height: 50 },
                  }),
                ],
              }),

              new Paragraph({
                spacing: {
                  after: 2000,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Semi-Annual Report Maintenance",
                    font: "Arial",
                    size: 60,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 4000,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "E-Office",
                    font: "Arial",
                    size: 40,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 200,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: formattedDate,
                    font: "Arial",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 200,
                },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Kementerian Investasi dan Hilirisasi/BKPM",
                    font: "Arial",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Infrastructure System",
                    font: "Arial",
                    size: 20,
                    italics: true,
                  }),
                ],
              }),

              // PAGE BREAK
              new Paragraph({
                children: [],
                pageBreakBefore: true,
              }),

              // SECOND PAGE
              new Paragraph({
                spacing: {
                  after: 80,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "HEALTH CHECK & UTILIZATION SUMMARY",
                    font: "Arial",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 80,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Semi-Annual Average Disk Utilization",
                    font: "Arial",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),
              new Paragraph({
                spacing: {
                  after: 500,
                },
                alignment: AlignmentType.CENTER,
                children: [
                  new TextRun({
                    text: "Period Last 6 Month",
                    font: "Arial",
                    size: 20,
                  }),
                ],
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: `Host ${value}`,
                    font: "Arial",
                    color: "000000",
                    size: 20,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new ImageRun({
                    data: imgData,
                    transformation: { width: 650, height: 400 },
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                children: [
                  new TextRun({
                    text: "Information :",
                    font: "Arial",
                    color: "000000",
                    size: 25,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              ...this.getCpuInfoParagraphs(),

              new Paragraph({
                children: [],
                pageBreakBefore: true,
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Analysis & Condition :",
                    font: "Arial",
                    size: 23,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              ...analysisParagraphs,

              new Paragraph({
                spacing: { after: 200 },
                children: [],
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.LEFT,
                children: [
                  new TextRun({
                    text: "Conclusion :",
                    font: "Arial",
                    size: 23,
                    bold: true,
                  }),
                ],
              }),

              new Paragraph({
                children: [],
              }),

              new Paragraph({
                spacing: { after: 80 },
                alignment: AlignmentType.JUSTIFIED,
                children: [
                  new TextRun({
                    text: paragraphText,
                    font: "Arial",
                    size: 20,
                  }),
                ],
              }),
            ],
          },
        ],
      });

      Packer.toBlob(doc).then((blob) => {
        saveAs(blob, "report-maintenance-disk-utilization-last-6-month.docx");
      });
    });
  };

  allGood = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Good");
  };

  allWarning = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Warning");
  };

  allBad = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Bad");
  };

  allIdle = (analysisResults) => {
    return analysisResults.every((result) => result.status === "Idle");
  };

  analyzeChartData = (datasets) => {
    if (!datasets || datasets.length === 0) {
      return "Data grafik tidak tersedia.";
    }

    const results = datasets.map((dataset) => {
      const average =
        dataset.data.reduce((sum, val) => sum + val, 0) / dataset.data.length;

      let status;

      if (average === 0) {
        status = "Idle";
      } else if (average <= 80) {
        status = "Good";
      } else if (average > 80 && average <= 85) {
        status = "Warning";
      } else {
        status = "Bad";
      }

      return {
        label: dataset.label,
        average: average.toFixed(2),
        status: status,
      };
    });

    return results;
  };

  convertImageToBase64 = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      fetch(imageUrl)
        .then((res) => res.blob())
        .then((blob) => {
          reader.onloadend = () => resolve(reader.result.split(",")[1]);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
        .catch(reject);
    });
  };

  getCpuInfoParagraphs = () => {
    const { data, dataHistory } = this.state;
    const { selectedHost } = this.props;

    if (!selectedHost || !Array.isArray(data)) return [];

    const value = selectedHost.value;
    const specificHost = data.find((item) => item.host.hostid === value);
    const itemId = specificHost ? specificHost.graph?.[0].itemid : null;
    const specificGraph = data.find(
      (item) => item.graph?.[0]?.itemid === itemId
    );
    const items =
      specificGraph && Array.isArray(specificGraph.graph)
        ? specificGraph.graph
        : [];

    const specificHistory = dataHistory.find(
      (item) => item.host.hostid === value
    );

    const graphIdHistory = specificHistory?.graph?.[0]?.itemid || null;

    const specificGraphHistory = dataHistory.find(
      (item) => item.graph?.[0]?.itemid === graphIdHistory
    );

    const itemsHistory =
      specificGraphHistory && Array.isArray(specificGraphHistory.graph)
        ? specificGraphHistory.graph
        : [];

    return items.map((item, index) => {
      const historyItem = itemsHistory.find(
        (historyItem) => historyItem.itemid === item.itemid
      );
      return new Paragraph({
        spacing: {
          after: 80,
        },
        children: [
          new TextRun({
            text: `${item.name} - `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Last:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${item.last !== null ? item.last : "0.000"}% | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Min:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${
              historyItem && historyItem.min !== null
                ? historyItem.min
                : "0.000"
            }% | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Average:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${
              historyItem && historyItem.average !== null
                ? historyItem.average
                : "0.000"
            }% | `,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
          new TextRun({
            text: "Max:",
            font: "Arial",
            color: "000000",
            size: 20,
            bold: true,
          }),
          new TextRun({
            text: ` ${
              historyItem && historyItem.max !== null
                ? historyItem.max
                : "0.000"
            }%`,
            font: "Arial",
            color: "000000",
            size: 20,
          }),
        ],
      });
    });
  };

  render() {
    const { loading, errorMessage } = this.state;
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              {loading ? (
                <div className="text-center">
                  <div>
                    <Spinner
                      style={{
                        width: "3rem",
                        height: "3rem",
                        borderWidth: "0.4rem",
                      }}
                      color="dark"
                    />
                  </div>
                  <div>
                    <span style={{ fontWeight: "bold" }}>
                      Mengambil Data ...
                    </span>
                  </div>
                </div>
              ) : errorMessage ? (
                <Card className="text-center">
                  <br />
                  <CardBody>
                    <h5 className="text-dark">{errorMessage}</h5>
                    <br />
                    <Button color="danger" onClick={this.fetchData}>
                      Muat Ulang
                    </Button>
                  </CardBody>
                </Card>
              ) : (
                <div>
                  <div style={{ textAlign: "right" }}>
                    <Button onClick={this.handleDownloadWord} color="primary">
                      <span className="uil-cloud-download"></span> Unduh Data
                    </Button>
                  </div>
                  <br />
                  <div>
                    <Line
                      ref={(ref) => (this.chartRef = ref && ref.chartInstance)}
                      data={this.createChart()}
                      options={{
                        responsive: true,
                        plugins: {
                          legend: {
                            position: "top",
                          },
                          tooltip: {
                            callbacks: {
                              label: function (context) {
                                return context.raw + "%";
                              },
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <hr />
            <Col className="col-12">{this.renderDiskUtilInfo()}</Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default withRouter(IndexView);
